module.exports = __webpack_public_path__ + "img/bg-hero-tax-accountants-v2.5bf9cfa.png";